module.exports = __webpack_public_path__ + "img/back-red.962ac7df.svg";